<template>
  <table
    class="common_table" v-bind="$attrs"
    :style="{ 'line-height': $attrs.lineHeight + 'px' }">
    <colgroup>
      <col v-for="column in columns" :key="column.prop" :width="columnWidth(column.width)">
    </colgroup>
    <thead>
      <tr :style="{ 'line-height': $attrs['lineHeight-head'] + 'px' }">
        <th v-for="column in columns" :key="column.prop" scope="col">{{ column.label }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in list" :key="index" :align="$attrs.align">
        <td v-for="(column, idx) in columns" :key="idx">
          <template v-if="column.type && column.type === 'slot'"><slot :[column.prop]="item" :name="column.prop" /></template>
          <template v-else><span class="ellipsis_one content_item">{{ column.func ? column.func(item[column.prop]) : item[column.prop] }}</span></template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'Table',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    columnWidth (width) {
      return width ? (width + 'px') : (100 / this.columns.length + '%')
    }
  }
}
</script>

<style lang="scss" scoped>
.common_table { width: 100%;
  tbody {
    tr {
      &:nth-child(2n + 1) { background-color: $default_primary_color_01; }
      &:hover { background-color: $default_primary_color_01; }
    }
  }
  .content_item { padding: 0 10px; }
}
</style>
